var _path, _rect, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.57227,
    y: 12,
    width: 12.8571,
    height: 6.42857,
    rx: 0.999983,
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H3",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.55 6.00006C14.55 6.02766 14.5276 6.05001 14.5 6.05C14.4724 6.04999 14.45 6.02762 14.45 6.00002C14.45 5.97242 14.4723 5.95003 14.4999 5.95C14.5132 5.94998 14.526 5.95525 14.5354 5.96464C14.5447 5.97404 14.55 5.98678 14.55 6.00006",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 6.00006C17.55 6.02766 17.5276 6.05001 17.5 6.05C17.4724 6.04999 17.45 6.02762 17.45 6.00002C17.45 5.97242 17.4723 5.95003 17.4999 5.95C17.5132 5.94998 17.526 5.95525 17.5354 5.96464C17.5447 5.97404 17.55 5.98678 17.55 6.00006",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55 6.00006C9.54997 6.02766 9.52758 6.05001 9.49998 6.05C9.47238 6.04999 9.45001 6.02762 9.45 6.00002C9.44999 5.97242 9.47234 5.95003 9.49994 5.95C9.51322 5.94998 9.52596 5.95525 9.53536 5.96464C9.54475 5.97404 9.55002 5.98678 9.55 6.00006",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55 6.00006C6.54997 6.02766 6.52758 6.05001 6.49998 6.05C6.47238 6.04999 6.45001 6.02762 6.45 6.00002C6.44999 5.97242 6.47234 5.95003 6.49994 5.95C6.51322 5.94998 6.52596 5.95525 6.53536 5.96464C6.54475 5.97404 6.55002 5.98678 6.55 6.00006",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOven);
export default __webpack_public_path__ + "static/media/oven.cfa7cfe6f69c069c308d3b723afc2bb5.svg";
export { ForwardRef as ReactComponent };